document.addEventListener("DOMContentLoaded", function () {

	// entry-content の通常画像
	document.querySelectorAll(".entry-content img").forEach(function (img) {
		img.classList.add("js-in");
		if (!img.closest("a")) {
			var a = document.createElement("a");
			a.href = img.src.replace(/-\d+x\d+(?=\.)/, "");
			a.classList.add("glightbox");
			img.parentNode.insertBefore(a, img);
			a.appendChild(img);
		}
	});

	GLightbox({
		selector: ".glightbox",
		loop: true
	});

});
